import siteRequest from '../../helpers/siteRequest';

const QuickAnswersRequest = () => {
    return { type: 'QUICK_ANSWERS_REQUEST' };
};

const QuickAnswersSuccess = quickAnswers => {
    return { type: 'QUICK_ANSWERS_SUCCESS', quickAnswers };
};

const QuickAnswersFailure = error => {
    return {
        type: 'QUICK_ANSWERS_FAILURE',
        error
    };
};

const quickAnswers = () => async dispatch => {
    try {
        dispatch(QuickAnswersRequest());

        const response = await siteRequest({
            method: 'get',
            url: '/wp-json/hamyar-faq/v1/quick_answers'
        });

        dispatch(QuickAnswersSuccess(response.data));

        return Promise.resolve(response.data);
    } catch (error) {
        dispatch(QuickAnswersFailure(error));
    }
};

const addQuickRequest = () => {
    return { type: 'ADD_QUICK_REQUEST' };
};

const addQuickSuccess = () => {
    return { type: 'ADD_QUICK_SUCCESS' };
};

const addQuickFailure = error => {
    return {
        type: 'ADD_QUICK_FAILURE',
        error
    };
};

const addQuick = content => async dispatch => {
    try {
        dispatch(addQuickRequest());

        await siteRequest({
            method: 'post',
            url: '/wp-json/hamyar-faq/v1/quick_answers',
            params: {
                content
            }
        });

        dispatch(addQuickSuccess());
    } catch (error) {
        dispatch(addQuickFailure(error));
    }
};

export {
    QuickAnswersRequest,
    QuickAnswersSuccess,
    QuickAnswersFailure,
    addQuickRequest,
    addQuickSuccess,
    addQuickFailure,
    addQuick,
    quickAnswers
};
